export default __webpack_public_path__ + "static/media/no_connection.a8181c1b.svg";